import { combineReducers } from "redux";

import layoutDataReducer from "./layoutData/reducer";
import positionReducer from "./fleetData/positionReducer";
import activeTabReducer from "./fleetData/activeTabReducer";
import vehicleFilterReducer from "./fleetData/vehicleFilterReducer";
import vehicleSelectedReducer from "./fleetData/vehicleSelectedReducer";
import gridDataReducer from "./gridData/reducer"

const rootReducer = combineReducers({
	layoutDataReducer,
	activeTabReducer,
	positionReducer,
	vehicleFilterReducer,
	vehicleSelectedReducer,
	gridDataReducer
});

export default rootReducer;